<template>
  <div style="height:auto">
    <div>
      <div class="ECMonitor-title">
        <div>AWS</div>
      </div>
      <Tabs v-model="activeName" @on-click="handleClickTabs">
        <TabPane
          :label="$t('OriginalBillEntry.BillingBucketConfiguration')"
          name="1"
        >
          <Form :model="searchConfigData" inline>
            <FormItem label="" v-if="companyId == 1">
              <Select
                v-model="searchConfigData.companyId"
                filterable
                :placeholder="$t('alarms.common.pleaseSelectCompany')"
                :transfer="true"
                @on-change="getAWSAccountByCompanyId"
              >
                <Option
                  :value="item.id"
                  v-for="item in companyList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="">
              <Input
                v-model="searchConfigData.accountName"
                :placeholder="$t('permission_configuration_management.group.checkByAccountType')"
              ></Input>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConfigData.payerAccountId"
                filterable
                clearable
                :max-tag-count="1"
                :placeholder="$t('Bill.ResourceOptimization.payAccount')"
                @on-change="getConfigData"
                :transfer="true"
              >
                <Option
                  :value="item.id"
                  v-for="item in accountList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="">
              <Input
                v-model="searchConfigData.bucketName"
                :placeholder="$t('RAM.common.QuerybyBucketName')"
              ></Input>
            </FormItem>
            <FormItem label="">
              <Button type="primary" @click="getConfigData">{{
                $t("OriginalBillEntry.select")
              }}</Button>
              <Button type="primary" @click="handleConfig">{{
                $t("OriginalBillEntry.config")
              }}</Button>
            </FormItem>
          </Form>
          <Table
            :columns="configColumns"
            :data="ConfigTableData"
            :no-data-text="$t('common.noData')"
            style="margin-bottom:10px"
          >
            <template slot-scope="{ row, index }" slot="operation">
              <Button
                type="primary"
                size="small"
                @click="handleGetSyncRecords(row)"
                >{{ $t("OriginalBillEntry.SynchronizeRecords") }}</Button
              >
              <Button type="error" size="small" @click="handleDel(row)">{{
                $t("OriginalBillEntry.del")
              }}</Button>
            </template>
          </Table>
          <div style="margin-bottom:70px">
            <Page
              style="margin-bottom:10px"
              :total="total"
              :current="searchConfigData.pageNum"
              :page-size="searchConfigData.pageSize"
              :transfer="true"
              show-sizer
              @on-change="handleChangePageNum"
              @on-page-size-change="handleChangePageSize"
            ></Page>
          </div>
        </TabPane>
        <TabPane :label="$t('OriginalBillEntry.uploadbill')" name="2">
          <Form :model="searchUploadData" inline>
            <FormItem label="" v-if="companyId == 1">
              <Select
                v-model="searchUploadData.companyId"
                filterable
                :placeholder="$t('alarms.common.pleaseSelectCompany')"
                :transfer="true"
                @on-change="getUploadAccountByCompanyId"
              >
                <Option
                  :value="item.id"
                  v-for="item in companyList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="">
              <Input
                v-model="searchUploadData.accountName"
                :placeholder="$t('permission_configuration_management.group.checkByAccountType')"
              ></Input>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchUploadData.region"
                filterable
                :placeholder="$t('RAM.common.PleaseSelectRegion')"
                :transfer="true"
                @on-change="getUploadData"
              >
                <Option
                  :value="item.id"
                  v-for="item in regionList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="">
              <DatePicker
                :value="searchUploadData.month"
                @on-change="handleChangeMonth($event)"
                type="month"
                format="yyyy-MM"
                :placeholder="$t('MCM.automaticalMaintenanceReport.pleaseSelectMonth')"
                style="width: 200px"
              ></DatePicker>
            </FormItem>
            <FormItem label="">
              <Button type="primary" @click="getUploadData">{{
                $t("OriginalBillEntry.select")
              }}</Button>
              <Button type="primary" @click="handleUpload">{{
                $t("OriginalBillEntry.upload")
              }}</Button>
            </FormItem>
          </Form>
          <Table
            :columns="uploadColumns"
            :data="uploadTableData"
            :no-data-text="$t('common.noData')"
            style="margin-bottom:10px"
          >
            <template slot-scope="{ row, index }" slot="operation">
              <Button type="primary" size="small" @click="handleDownload(row)"
                >{{ $t("BillingServices.download") }}</Button
              >
              <Button
                type="primary"
                size="small"
                @click="handleGetSyncRecords(row)"
                >{{ $t("OriginalBillEntry.SynchronizeRecords") }}</Button
              >
              <Button type="error" size="small" @click="handleDel(row)">{{
                $t("OriginalBillEntry.del")
              }}</Button>
            </template>
          </Table>
          <div style="margin-bottom:70px">
            <Page
              :total="uploadTotal"
              :current="searchUploadData.pageNum"
              :page-size="searchUploadData.pageSize"
              :transfer="true"
              show-sizer
              @on-change="handleChangePageNumByUpload"
              @on-page-size-change="handleChangePageSizeByUpload"
            ></Page>
          </div>
        </TabPane>
      </Tabs>
      <!-- footer-hide	隐藏底部 -->
      <!-- 上传账单 -->
      <Modal
        v-model="uploadModal"
        :title="$t('OriginalBillEntry.upload')"
        :mask-closable="false"
        width="600"
        @on-cancel="uploadCancel"
      >
        <Form
          :model="addUploadData"
          :label-width="130"
          ref="addUploadForm"
          :rules="ruleByUpload"
        >
          <FormItem
            :label="$t('OriginalBillEntry.company') + '：'"
            v-if="companyId == 1"
            prop="companyId"
          >
            <Select
              v-model="addUploadData.companyId"
              filterable
              :placeholder="$t('alarms.common.pleaseSelectCompany')"
              :transfer="true"
              @on-change="getUploadByCompanyId"
              style="width:200px"
            >
              <Option
                :value="item.id"
                v-for="item in companyList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            :label="$t('OriginalBillEntry.account') + '：'"
            prop="accountIds"
          >
            <Select
              v-model="addUploadData.accountIds"
              filterable
              multiple
              :max-tag-count="1"
              :placeholder="$t('permission_configuration_management.group.checkByAccountType')"
              @on-change="changeAccountIdByUpload(addUploadData.accountIds)"
              :transfer="true"
              style="width:200px"
            >
              <Checkbox
                v-model="singleAccount"
                @on-change="selectAccountAll1"
                style="display: block; text-align: right"
                v-if="UploadAccountList.length > 0"
                >{{ $t("alarms.common.allSelected") }}</Checkbox
              >
              <Option
                :value="item.id"
                v-for="item in UploadAccountList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            :label="$t('OriginalBillEntry.PaymentAccount') + '：'"
            prop="payerAccountIdString"
          >
            <Input
              v-model="addUploadData.payerAccountIdString"
              style="width: 200px"
            ></Input>
          </FormItem>
          <FormItem
            :label="$t('OriginalBillEntry.region') + '：'"
            prop="region"
          >
            <Select
              v-model="addUploadData.region"
              filterable
              :placeholder="$t('RAM.common.PleaseSelectRegion')"
              :transfer="true"
              style="width:200px"
            >
              <Option
                :value="item.id"
                v-for="item in regionList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem :label="$t('OriginalBillEntry.month') + '：'" prop="month">
            <DatePicker
              type="month"
              v-model="addUploadData.month"
              format="yyyy-MM"
              :placeholder="$t('MCM.automaticalMaintenanceReport.pleaseSelectMonth')"
              style="width: 200px"
            ></DatePicker>
          </FormItem>
          <FormItem :label="$t('OriginalBillEntry.uploadAttachment')" :required="true">
            <!-- action 为后端地址 -->
            <Upload
              ref="uploadRef"
              multiple
              type="drag"
              :action="actionUrl"
              style="width:400px"
              :show-upload-list="true"
              :on-success="uploadSuccess"
              :on-remove="handleRemove"
              :headers="{
                userName: userName,
                Authorization: Authorization
              }"
            >
              <div style="padding: 20px 0">
                <Icon
                  type="ios-cloud-upload"
                  size="52"
                  style="color: #3399ff"
                ></Icon>
                <p>{{ $t("OriginalBillEntry.uploadMsg") }}</p>
              </div>
            </Upload>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="uploadCancel" :disabled="isDisable"
            >{{ $t("OriginalBillEntry.cancel") }}
          </Button>
          <Button
            type="primary"
            @click="handleConfirmUpload"
            :disabled="isDisable"
            >{{ $t("OriginalBillEntry.confirm") }}
          </Button>
        </div>
      </Modal>
      <!-- 配置 -->
      <Modal
        v-model="configModal"
        :title="$t('OriginalBillEntry.config')"
        :mask-closable="false"
        @on-cancel="configCancel"
      >
        <Form
          :model="addConfigData"
          :label-width="130"
          ref="addConfigForm"
          :rules="rule"
        >
          <FormItem
            :label="$t('OriginalBillEntry.company') + '：'"
            v-if="companyId == 1"
            prop="companyId"
          >
            <Select
              v-model="addConfigData.companyId"
              filterable
              :placeholder="$t('alarms.common.pleaseSelectCompany')"
              :transfer="true"
              @on-change="getaddAccountByCompanyId"
              style="width:200px"
            >
              <Option
                :value="item.id"
                v-for="item in companyList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            :label="$t('OriginalBillEntry.account') + '：'"
            prop="accountIds"
          >
            <Select
              v-model="addConfigData.accountIds"
              filterable
              multiple
              :max-tag-count="1"
              :placeholder="$t('permission_configuration_management.group.checkByAccountType')"
              @on-change="changeAccountId(addConfigData.accountIds)"
              :transfer="true"
              style="width:200px"
            >
              <Checkbox
                v-model="singleAccount"
                @on-change="selectAccountAll2"
                style="display: block; text-align: right"
                v-if="accountList.length > 0"
                >{{ $t("alarms.common.allSelected") }}</Checkbox
              >
              <Option
                :value="item.id"
                v-for="item in accountList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            :label="$t('OriginalBillEntry.PaymentAccount') + '：'"
            prop="payerAccountId"
          >
            <Select
              v-model="addConfigData.payerAccountId"
              filterable
              :max-tag-count="1"
              :placeholder="$t('Bill.ResourceOptimization.payAccount')"
              @on-change="getaddConfigData"
              :transfer="true"
              style="width:200px"
            >
              <Option
                :value="item.id"
                v-for="item in accountList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            :label="$t('OriginalBillEntry.bucketName') + '：'"
            prop="bucketName"
          >
            <Input
              v-model="addConfigData.bucketName"
              :placeholder="$t('RAM.common.QuerybyBucketName')"
              style="width:200px"
            ></Input>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="configCancel" :disabled="isDisable"
            >{{ $t("OriginalBillEntry.cancel") }}
          </Button>
          <Button type="primary" @click="handleok" :disabled="isDisable"
            >{{ $t("OriginalBillEntry.confirm") }}
          </Button>
        </div>
      </Modal>
      <!-- 同步记录 -->
      <Modal
        footer-hide
        v-model="syncNotesModal"
        :title="$t('OriginalBillEntry.SynchronizeRecords')"
      >
        <Form :model="syncNotesData" inline>
          <FormItem label="">
            <DatePicker
              v-model="syncNotesData.startTime"
              type="date"
              :placeholder="$t('satisfaction.pleaseSelectStartTime')"
              style="width: 150px"
            ></DatePicker>
          </FormItem>
          <FormItem label="">
            <DatePicker
              v-model="syncNotesData.endTime"
              type="date"
              :placeholder="$t('satisfaction.pleaseSelectEndTime')"
              style="width: 150px"
            ></DatePicker>
          </FormItem>
          <FormItem label="">
            <Button type="primary" @click="getSyncNotesData">{{
              $t("OriginalBillEntry.select")
            }}</Button>
          </FormItem>
        </Form>
        <Table
          :columns="SyncNotesColumns"
          :data="SyncNotesTableData"
          :no-data-text="$t('common.noData')"
          style="margin-bottom:10px"
        >
        </Table>
        <Page
          :total="SyncNotesTotal"
          :current="syncNotesData.pageNum"
          :page-size="syncNotesData.pageSize"
          :transfer="true"
          show-sizer
          @on-change="handleChangePageNumBySyncNotes"
          @on-page-size-change="handleChangePageSizeBySyncNotes"
        ></Page>
      </Modal>
      <!-- 删除 -->
      <Modal v-model="delModal" width="360" :mask-closable="false">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
        </p>
        <div style="text-align:center">
          <p>
            {{ $t("alarms.common.sureDelete") }} {{ Name }}
            {{ $t("alarms.common.what") }}?
          </p>
        </div>
        <div slot="footer">
          <Button
            type="error"
            size="large"
            long
            @click="handleConfirmDel"
            :disabled="isDisable"
            >{{ $t("alarms.common.delete") }}
          </Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import log from "../../../../api/log";
import { getCookie } from "../../../../utils/cookieUtil";
export default {
  data() {
    return {
      userName: getCookie(global.cookieName),
      Authorization: getCookie("Authorization"),
      getRowId: "",
      SyncNotesTotal: 0,
      singleAccount: false,
      configAccount: false,
      delModal: false,
      configModal: false,
      isDisable: false,
      syncNotesModal: false,
      uploadModal: false,
      actionUrl: "",
      activeName: "1",
      total: 0,
      uploadTotal: 0,
      Name: "",
      companyId: getCookie(global.companyId),
      searchConfigData: {
        companyId: null,
        accountName: null,
        payerAccountId: null,
        bucketName: null,
        pageNum: 1,
        pageSize: 10
      },
      searchUploadData: {
        companyId: null,
        accountName: null,
        region: null,
        month: null,
        pageNum: 1,
        pageSize: 10
      },
      addConfigData: {
        companyId: null,
        accountIds: [],
        payerAccountId: null,
        bucketName: null
      },
      addUploadData: {
        companyId: null,
        accountIds: [],
        payerAccountIdString: null,
        region: null,
        month: null,
        fileIds: []
      },
      syncNotesData: {
        rowId: "",
        startTime: null,
        endTime: null,
        pageSize: 10,
        pageNum: 1
      },
      getRowData: {},
      companyList: [],
      SyncNotesTableData: [],
      UploadAccountList: [],
      accountList: [],
      payerAccountIdList: [],
      regionList: [
        { name: "国内", id: 1 },
        { name: "国外", id: 2 }
      ],
      configColumns: [
        {
          title: this.$t("OriginalBillEntry.accountNumberName"),
          key: "accountName",
          minWidth: 100
        },
        {
          title: this.$t("OriginalBillEntry.accountID"),
          key: "accountId",
          minWidth: 100
        },
        {
          title: this.$t("OriginalBillEntry.bucketName"),
          key: "bucketName",
          minWidth: 100
        },
        {
          title: this.$t('OriginalBillEntry.PaymentAccount'),
          key: "payerAccount",
          minWidth: 100
        },
        {
          title: this.$t("ticket.list.operation"),
          key: "",
          minWidth: 100,
          slot: "operation"
        }
      ],
      ConfigTableData: [],
      SyncNotesColumns: [
        {
          title: this.$t("OriginalBillEntry.syncStatus"),
          key: "stateString",
          minWidth: 100
        },
        {
          title: this.$t("OriginalBillEntry.syncRecord"),
          key: "message",
          minWidth: 100
        },
        {
          title: this.$t("OriginalBillEntry.syncTime"),
          key: "modifiedTime",
          minWidth: 100
        }
      ],
      uploadColumns: [
        {
          title: this.$t("OriginalBillEntry.accountNumberName"),
          key: "accountName",
          minWidth: 100
        },
        {
          title: this.$t("OriginalBillEntry.accountID"),
          key: "accountId",
          minWidth: 100
        },
        {
          title: this.$t("OriginalBillEntry.month"),
          key: "month",
          minWidth: 100
        },
        {
          title: this.$t("OriginalBillEntry.fileName"),
          key: "fileName",
          minWidth: 100
        },
        {
          title: this.$t("ticket.list.operation"),
          key: "",
          minWidth: 100,
          slot: "operation"
        }
      ],
      uploadTableData: [],
      SyncNotesData: [],
      getfileList: [],
      rule: {
        companyId: [
          {
            required: true,
            message: this.$t("alarms.common.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        accountIds: [
          {
            required: true,
            message: this.$t('alarms.common.pleaseSelectAccount'),
            trigger: "change",
            type: "array"
          }
        ],
        payerAccountId: [
          {
            required: true,
            message: this.$t('Bill.ResourceOptimization.payAccount'),
            trigger: "change",
            type: "number"
          }
        ],
        bucketName: [
          {
            required: true,
            message: this.$t('RAM.common.QuerybyBucketName'),
            trigger: "blur"
          }
        ]
      },
      ruleByUpload: {
        companyId: [
          {
            required: true,
            message: this.$t("alarms.common.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        accountIds: [
          {
            required: true,
            message: this.$t('alarms.common.pleaseSelectAccount'),
            trigger: "change",
            type: "array"
          }
        ],
        payerAccountIdString: [
          {
            required: true,
            message: this.$t("OriginalBillEntry.pleaseEnterPayAccount")
          }
        ],
        region: [
          {
            required: true,
            message: this.$t('alarms.complianceChecks.PleaseSelectRegion'),
            trigger: "change",
            type: "number"
          }
        ],
        month: [
          {
            required: true,
            message: this.$t('MCM.automaticalMaintenanceReport.pleaseSelectMonth'),
            trigger: "change",
            type: "date"
          }
        ]
      }
    };
  },
  methods: {
    handleChangeMonth($event) {
      this.searchUploadData.month = $event;
    },
    handleClickTabs(name) {
      if (name == 1) {
        this.getConfigData();
      } else {
        this.getUploadData();
      }
    },
    // 上传成功
    uploadSuccess(res, file, fileList) {
      this.getfileList = fileList;
      this.$Message.success(this.$t("resourceLifecycle.response.uploadSuccess"));
      this.addUploadData.fileIds.push(file.response.id);
    },
    handleRemove(file, fileList) {
      this.$api.originalBillEntry
        .deleteBillDataS3({ idList: [file.response.id] })
        .then(res => {
          this.$Message.success(this.$t("resourceLifecycle.response.deleteSuccess"));
          this.addUploadData.fileIds = [];
          for (var i = 0; i < fileList.length; i++) {
            this.addUploadData.fileIds.push(fileList[i].response.id);
          }
        });
    },
    handleCancelRemove(file, fileList) {
      if (this.addUploadData.fileIds.length == 0) {
        return;
      }
      this.$api.originalBillEntry
        .deleteBillDataS3({ idList: this.addUploadData.fileIds })
        .then(res => {
          this.$Message.success(this.$t("resourceLifecycle.response.deleteSuccess"));
          this.addUploadData.fileIds = [];
          for (var i = 0; i < this.getfileList.length; i++) {
            this.addUploadData.fileIds.push(this.getfileList[i].response.id);
          }
        });
    },
    handleDownload(row) {
      this.$api.originalBillEntry
        .downLoadBillDataSourceConfig("id", row.id)
        .then(res => {
          let aTag = document.createElement("a");
          let blob = new Blob([res.data], { type: "text/plain;charset=UTF-8" });
          aTag.download = row.fileName;
          aTag.href = URL.createObjectURL(blob);
          aTag.click();
          URL.revokeObjectURL(blob);
          setTimeout(() => {
            this.modal_loadings = false;
            this.$Message.success(
              this.$t("resourceLifecycle.response.downloadSuccess")
            );
          }, 1000);
        });
    },
    // 切换账户
    changeAccountId: function(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    changeAccountIdByUpload: function(val) {
      if (val.length === this.UploadAccountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    selectAccountAll2() {
      this.addConfigData.accountIds = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.addConfigData.accountIds.push(item.id);
        });
      } else {
        this.addConfigData.accountIds = [];
      }
    },
    selectAccountAll1() {
      this.addUploadData.accountIds = [];
      if (this.singleAccount) {
        this.UploadAccountList.map(item => {
          this.addUploadData.accountIds.push(item.id);
        });
      } else {
        this.addUploadData.accountIds = [];
      }
    },
    handleChangePageNum(pageNum) {
      this.searchConfigData.pageNum = pageNum;
      this.getConfigData();
    },
    handleChangePageSize(pageSize) {
      this.searchConfigData.pageSize = pageSize;
      this.getConfigData();
    },
    handleChangePageNumByUpload(pageNum) {
      this.searchUploadData.pageNum = pageNum;
      this.getUploadData();
    },
    handleChangePageSizeByUpload(pageSize) {
      this.searchUploadData.pageSize = pageSize;
      this.getUploadData();
    },
    handleChangePageNumBySyncNotes(pageNum) {
      this.syncNotesData.pageNum = pageNum;
      this.getSyncNotesData();
    },
    handleChangePageSizeBySyncNotes(pageSize) {
      this.syncNotesData.pageSize = pageSize;
      this.getSyncNotesData();
    },
    handleGetSyncRecords(row) {
      this.syncNotesModal = true;
      this.getRowId = row.id;
      this.getSyncNotesData();
    },
    handleDel(row) {
      this.Name = row.name;
      this.getRowData = row;
      this.delModal = true;
    },
    handleConfirmDel() {
      this.$api.originalBillEntry
        .deleteBilldataSourceConfig("id", this.getRowData.id)
        .then(res => {
          this.$Message.success(this.$t("resourceLifecycle.response.deleteSuccess"));
          this.delModal = false;
          if (this.activeName == "1") {
            this.getConfigData();
          } else {
            this.getUploadData();
          }
        });
    },
    handleok() {
      this.$refs.addConfigForm.validate(valid => {
        if (valid) {
          this.$api.originalBillEntry
            .createBillDataSourceConfig(this.addConfigData)
            .then(res => {
              this.getConfigData();
              this.configModal = false;
              this.$refs.addConfigForm.resetFields();
            })
            .catch(err => {
              this.$Message.error(decodeURI(err.headers.message));
            });
        } else {
          this.configModal = true;
          this.$Message.error("请输入完整");
          return false;
        }
      });
    },

    //格式化时间
    format(dat) {
      //获取年月日，时间
      var year = dat.getFullYear();
      var mon =
        dat.getMonth() + 1 < 10
          ? "0" + (dat.getMonth() + 1)
          : dat.getMonth() + 1;
      var data = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
      var hour = dat.getHours() < 10 ? "0" + dat.getHours() : dat.getHours();
      var min =
        dat.getMinutes() < 10 ? "0" + dat.getMinutes() : dat.getMinutes();
      var seon =
        dat.getSeconds() < 10 ? "0" + dat.getSeconds() : dat.getSeconds();

      var newDate = year + "-" + mon;
      //  "-" + data + " " + hour + ":" + min + ":" + seon

      return newDate;
    },
    handleConfirmUpload() {
      this.$refs.addUploadForm.validate(valid => {
        if (valid) {
          let _data = {
            companyId: this.addUploadData.companyId,
            accountIds: this.addUploadData.accountIds,
            payerAccountIdString: this.addUploadData.payerAccountIdString,
            region: this.addUploadData.region,
            month: this.format(this.addUploadData.month),
            fileIds: this.addUploadData.fileIds
          };
          if (this.addUploadData.fileIds.length == 0) {
            this.$Message.error("请上传附件");
            return;
          }
          this.$api.originalBillEntry
            .uploadBillDataSourceConfigConfirm(_data)
            .then(res => {
              this.$Message.success(this.$t("resourceLifecycle.response.uploadSuccess"));
              this.uploadModal = false;
              this.getUploadData();
              this.$refs.addUploadForm.resetFields();
              this.addUploadData.fileIds = [];
            })
            .catch(err => {
              this.$Message.error(decodeURI(err.headers.message));
            });
        } else {
          this.uploadModal = true;
          this.$Message.error("请输入完整");
          return false;
        }
      });
    },
    configCancel() {
      this.configModal = false;
      this.addConfigData = {
        companyId: null,
        accountName: null,
        payerAccountId: null,
        bucketName: null
      };
      this.$refs.addConfigForm.resetFields();
    },
    uploadCancel() {
      this.uploadModal = false;
      this.handleCancelRemove();
      this.addUploadData = {
        companyId: null,
        accountName: null,
        payerAccountId: null,
        bucketName: null,
        region: null,
        month: null,
        fileIds: []
      };
      this.$refs.addUploadForm.resetFields();
      this.$refs.uploadRef.clearFiles();
    },
    handleConfig() {
      this.configCancel();
      this.configModal = true;
    },
    handleUpload() {
      this.uploadModal = false;
      this.addUploadData = {
        companyId: null,
        accountName: null,
        payerAccountId: null,
        bucketName: null,
        region: null,
        month: null,
        fileIds: []
      };
      this.$refs.addUploadForm.resetFields();
      this.$refs.uploadRef.clearFiles();
      this.uploadModal = true;
    },
    //  获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 账号下拉框
    getAWSAccountByCompanyId: function() {
      this.$api.account
        .getAWSAccountByCompanyId("companyId", this.searchConfigData.companyId)
        .then(res => {
          this.accountList = res.data;
          //默认账户全选
          if (this.accountList) {
            for (var i = 0; i < this.accountList.length; i++) {
              this.searchConfigData.payerAccountId.push(this.accountList[i].id);
            }
          }
          this.getConfigData();
        });
    },
    getUploadByCompanyId() {
      if (this.addUploadData.companyId == undefined) {
        return;
      }
      this.$api.account
        .getAWSAccountByCompanyId("companyId", this.addUploadData.companyId)
        .then(res => {
          this.UploadAccountList = res.data;
        });
    },
    getUploadAccountByCompanyId() {
      this.$api.account
        .getAWSAccountByCompanyId("companyId", this.searchUploadData.companyId)
        .then(res => {
          this.UploadAccountList = res.data;
          //默认账户全选
          if (this.accountList) {
            for (var i = 0; i < this.UploadAccountList.length; i++) {
              this.searchUploadData.account.push(this.UploadAccountList[i].id);
            }
          }
          this.getUploadData();
        });
    },
    getaddAccountByCompanyId() {
      if (!this.addConfigData.companyId) {
        return;
      }
      this.$api.account
        .getAWSAccountByCompanyId("companyId", this.addConfigData.companyId)
        .then(res => {
          this.accountList = res.data;
          //默认账户全选
          if (this.accountList) {
            for (var i = 0; i < this.accountList.length; i++) {
              this.addConfigData.accountIds.push(this.accountList[i].id);
            }
          }
          this.getConfigData();
        });
    },
    getConfigData() {
      this.$api.originalBillEntry
        .selectBilldataSourceConfig(this.searchConfigData)
        .then(res => {
          this.ConfigTableData = res.data.records;
          this.total = res.data.total;
        });
    },
    getaddConfigData() {},
    getSyncNotesData() {
      this.syncNotesData.rowId = this.getRowId;
      this.$api.originalBillEntry
        .selectSyncRecord(this.syncNotesData)
        .then(res => {
          this.SyncNotesTotal = res.data.total;
          this.SyncNotesTableData = res.data.records;
        });
    },
    getUploadData() {
      this.$api.originalBillEntry
        .selectUpLoadBilldataSourceConfig(this.searchUploadData)
        .then(res => {
          this.uploadTableData = res.data.records;
          this.uploadTotal = res.data.total;
        });
    }
  },
  mounted() {
    this.getCompanyDropDownBox();
    this.getConfigData();
    // 上传附件接口
    this.actionUrl =
      process.env.API_ROOT + "/sme/billDataSourceConfig/uploadBillDataS3";
  }
};
</script>

<style scoped>
.ECMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/OriginalBillEntry/aws/OriginalBillEntry.vue